import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/A6';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得投資標的轉換條款說明
export function getAgreeTermsA6() {
    return get(`${url}/getAgreeTerms`);
};

// 投資標的轉換條款同意
export function postAgreeA6() {
    return post(`${url}/agree`);
};

/**
 * 保戶進入投資標的轉換前，取得先前投資標的記錄
 * @return {Object}
 */
export function getInfoA6() {
    return get(`${url}/info`);
};

/**
 * 取得投資標的公司及投資標的名稱下拉式選單
 * @return {Object}
 */
export function getFundBankInfoA6() {
    return get(`${url}/fundBankInfo`);
}

// 投資標的轉換送出
// {
//     "transformOutList": [
//       {
//         "fundCode": "string",
//         "redeemUnit": 0,
//         "redeemPercent": 0
//       }
//     ],
//     "transformInList": [
//       {
//         "fundCode": "string",
//         "transferPercent": 0
//       }
//     ]
//   }
export function submitA6(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
};

/**
 * 顯示所選基金之申購/贖回 手續費
 * @return {Object}
 */
export function fundCodeInfo(data){
    return post(`${url}/fundCodeInfo`,data,{ ...options,repeatRequestCancel : true});
}
